import React from 'react';

const Features: React.FC = () => {
  return (
    <div className='features'>
      <div className='first-row'>
        <div className='mobile-box'>
          <h3>Mobile Banking</h3>
          <i className='fas fa-mobile-alt'></i>
          <p>
            Our modern app-like user interface on mobile devices makes banking
            on the go easier than ever.
          </p>
        </div>
        <div className='account-box'>
          <h3>Multiple Accounts</h3>
          <i className='fas fa-money-check'></i>
          <p>
            Open both a checking and savings account for free with no intial
            deposit required. You can open up to 5 different accounts in total!
          </p>
        </div>
      </div>
      <div className='second-row'>
        <div className='box deposit-box'>
          <h3>Make Deposits</h3>
          <i className='fas fa-dollar-sign'></i>
          <p>
            Making deposits is easy. No need to come all the way to the bank
            when you can deposit from the comfort of your home.
          </p>
        </div>
        <div className='box withdraw-box'>
          <h3>Withdraw Cash</h3>
          <i className='fas fa-wallet'></i>
          <p>
            Withdraw money from your account from our many ATM locations or from
            the bank.
          </p>
        </div>
        <div className='box transfer-box'>
          <h3>Transfer Money</h3>
          <i className='fas fa-exchange-alt'></i>
          <p>
            Transfer money between multiple accounts whether they are checking
            or savings accounts.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Features;
